var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomV2HealthUnsure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 9.99998H11.6667",
    stroke: "#7A7670",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.93417 16.7675L3.23167 14.065C2.76306 13.5962 2.49987 12.9604 2.5 12.2975V7.7025C2.4998 7.03944 2.76334 6.40354 3.2325 5.935L5.935 3.2325C6.40354 2.76334 7.03944 2.4998 7.7025 2.5H12.2975C12.9606 2.4998 13.5965 2.76334 14.065 3.2325L16.7683 5.93583C17.2369 6.40468 17.5001 7.04046 17.5 7.70333V12.2975C17.5 12.9603 17.2368 13.5961 16.7683 14.065L14.0658 16.7683C13.5966 17.2368 12.9606 17.5 12.2975 17.5H7.7025C7.03923 17.5001 6.40312 17.2366 5.93417 16.7675Z",
    stroke: "#7A7670",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomV2HealthUnsure);
export default __webpack_public_path__ + "static/media/customV2HealthUnsure.0fd8900ced233302d66361dcd1b1345b.svg";
export { ForwardRef as ReactComponent };